import { render, staticRenderFns } from "./office-edit.vue?vue&type=template&id=856fd84a&scoped=true&"
import script from "./office-edit.vue?vue&type=script&lang=js&"
export * from "./office-edit.vue?vue&type=script&lang=js&"
import style0 from "./office-edit.vue?vue&type=style&index=0&id=856fd84a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856fd84a",
  null
  
)

export default component.exports